import { AdminRideQuery, AdminRideSortBy, AdminRideStatus, AdminRideType } from '../api/client';
import { shiftCalendarDay, viennaDay, viennaMidnight } from './bookingFilters';

export const rideStatuses: Array<'' | AdminRideStatus> = ['', 'SCHEDULED', 'STARTED', 'COMPLETED', 'CANCELLED', 'EXPIRED'];
export const rideTypes: Array<'' | AdminRideType> = ['', 'RECURRING', 'SINGLE'];
export const ridePeriods = ['all', 'today', 'next7', 'last30', 'range'] as const;

function choice<T extends string>(value: string | null, options: readonly T[], fallback: T): T {
  return options.includes(value as T) ? value as T : fallback;
}

export function readRideFilters(search: URLSearchParams) {
  const rawPage = Number(search.get('page') || 0);
  const rawSize = Number(search.get('size') || 10);
  const period = choice(search.get('period'), ridePeriods, 'all');
  const userId = search.get('userId')?.trim() || '';
  return {
    page: Number.isInteger(rawPage) && rawPage >= 0 ? Math.min(rawPage, 1000000) : 0,
    size: [10, 20, 50, 100].includes(rawSize) ? rawSize : 10,
    q: search.get('q') || '',
    status: choice(search.get('status'), rideStatuses, ''),
    rideType: choice(search.get('rideType'), rideTypes, ''),
    sortBy: choice<AdminRideSortBy>(search.get('sortBy'), ['time', 'createdAt'], 'time'),
    sortDirection: choice<'ASC' | 'DESC'>(search.get('sortDirection'), ['ASC', 'DESC'], period === 'next7' || period === 'today' ? 'ASC' : 'DESC'),
    userId,
    userName: search.get('userName')?.trim() || userId,
    userRole: userId ? choice(search.get('userRole'), ['', 'DRIVER', 'RIDER'] as const, '') : '',
    communityId: search.get('communityId')?.trim() || '',
    eventId: search.get('eventId')?.trim() || '',
    period,
    start: search.get('start') || '',
    end: search.get('end') || '',
  };
}

export function rideQuery(search: URLSearchParams, now: Date): AdminRideQuery {
  const filters = readRideFilters(search);
  const query: AdminRideQuery = { page: filters.page, size: filters.size, sortBy: filters.sortBy, sortDirection: filters.sortDirection };
  if (filters.q.trim()) query.q = filters.q.trim();
  if (filters.status) query.status = filters.status;
  if (filters.rideType) query.rideType = filters.rideType;
  if (filters.userId) query.userId = filters.userId;
  if (filters.userRole) query.userRole = filters.userRole;
  if (filters.communityId) query.communityId = filters.communityId;
  if (filters.eventId) query.eventId = filters.eventId;
  if (filters.period === 'all') return query;
  const today = viennaDay(now);
  let start = today;
  let end = today;
  if (filters.period === 'next7') end = shiftCalendarDay(today, 6);
  if (filters.period === 'last30') start = shiftCalendarDay(today, -29);
  if (filters.period === 'range') {
    start = filters.start;
    end = filters.end;
    if (!start || !end || start > end) throw new Error('Invalid range');
  }
  return { ...query, from: viennaMidnight(start), to: viennaMidnight(shiftCalendarDay(end, 1)) };
}
